import type { Assignment } from '@/api/schedule';
import dayjs from '@/lib/dayjs';

const DAY_NAMES = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];

/** Assignments, die an einem Tag Stunden haben (Arbeitstage beachtet), mit den Stunden des Tages. */
export function plannedOn(assignments: Assignment[], date: string, workingDays: Set<string>): { assignment: Assignment; hours: number }[] {
  const dow = DAY_NAMES[dayjs(date).day()]!;
  return assignments
    .filter((a) => a.startDate <= date && a.endDate >= date && (a.includeNonWorking || workingDays.has(dow)))
    .map((a) => ({ assignment: a, hours: a.hoursPerDay }));
}
